// extracted by mini-css-extract-plugin
module.exports = {"root":"ResultCounts__root___KZX8w","value":"ResultCounts__value___SvitU"};